module.exports = __webpack_public_path__ + "img/25.e6581f9c.jpeg";